export const TIME_SHOW_PRODUCT_ASSOCIATED: number = 900 // en ms